module.exports = __webpack_public_path__ + "static/media/jp_logo.959555bc.jpg";